<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--header-->
      <!--<div class="nav_bar">-->
        <!--<button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
        <!--<p class="clear_style fl nav_bar_search tc">确认下单</p>-->
      <!--</div>-->

      <!--content-->
      <div class="cart_content">
        <!--address-->
        <div class="content_item" v-if="shoppingAddress.contactMechId != undefined">
          <router-link :to="{name:'addressList',query:{fromUrl:'order'}}">
            <p class="clear_style zt16 black">{{shoppingAddress.toName}}<span class="address_phone">{{shoppingAddress.contactNumber}}</span><span v-if="shoppingAddress.isDefault == 'Y'" class="zt12 fr address_default_tag">默认</span></p>
            <div class="clear_style zt14 grey">
              <p class="clear_style address_address1">{{shoppingAddress.address}}</p>
              <img class="fr address_detail_icon" src="@/images/icon_arrow_Put away@3x.png">
            </div>
          </router-link>
        </div>
        <div class="content_item" v-if="shoppingAddress.contactMechId == undefined">
          <router-link :to="{name:'addressList',query:{fromUrl:'order'}}">
            <p class="tc grey zt16" style="padding: 1rem 0">没有收货地址,去添加收货地址</p>
          </router-link>
        </div>
        <!--payMthod-->
        <div class="content_item">
          <p class="clear_style zt14 black">支付方法<span class="fr address_phone">微信支付</span></p>
        </div>
        <!--products-->
        <div class="content_item">
          <div class="cart_group_item" v-for="(item,index) in productList" @key="index">
            <div v-if="item.isPromo == 'N'" style="margin-bottom: 0.5rem">
              <div  class="clear_both" style="padding: 0.1rem 0.1rem;">
                <van-image class="full_w fl group_item_img" :src="item.imageUrl" fit="cover" />
                <div class="fl group_item_name" >
                  <p class="zt14 clear_style black">{{item.productName}}</p>
                  <p class="clear_style fl zt12 group_item_feature"><span class="fl" style="width: 13rem;;padding: 0.1rem 0.3rem">{{getFeatureString(item.productFeatureList)}}<span class="fr" style="width: 0.8rem;height: 0.8rem;margin-top: 0.1rem;margin-left: 0.5rem">x{{item.quantity}}</span></span></p>
                  <div class="clear_both">
                    <span class="fl zt14" style="color: #EB84AB">¥{{item.price}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="item.isPromo == 'Y'" style="margin-bottom: 0.5rem">
              <div  class="clear_both" style="padding: 0.1rem 0.1rem;">
                <p class="clear_style fl black zt12" v-if="item.isPromo" style="padding: 0rem 1rem;width: 20rem">赠品:{{item.productName}}<span>x{{item.quantity}}</span></p>
              </div>
            </div>
          </div>
        </div>


        <!--shipping-->
        <div class="content_item">
          <p class="clear_style zt14 black">配送方式<span class="fr address_phone">{{shipMethod.description}}</span></p>
        </div>
        <!--coupons-->
        <div class="content_item">
          <p class="clear_style zt14 black" @click="showActivity()">优惠券<img class="address_detail_icon fr" style="margin: 0.15rem" src="@/images/icon_arrow_Put away@3x.png"><span class="fr address_phone themeColor zt12">{{productPromoCodeList.length > 0 ? productPromoCodeList[0].productPromoName:'无可用'}}</span></p>
        </div>
        <div class="content_item">
          <p class="clear_style clear_both zt14 black">折扣信息<span v-for="(item,index) in promoUseList" @key="index" class="fr" style="width: 15rem;text-align: right" >{{item.description == undefined? '无可用':item.description}}</span></p>
        </div>
        <div class="content_item">
          <p class="clear_style zt14 black" style="padding: 0.2rem 0">商品金额<span class="fr themeColor" >¥{{productAmount}}</span></p>
          <p class="clear_style zt14 black" style="padding: 0.2rem 0">运费<span class="fr themeColor" >¥{{freight}}</span></p>
          <p class="clear_style zt14 black" style="padding: 0.2rem 0">立减<span class="fr themeColor" >-¥{{favorable}}</span></p>
        </div>
        <div class="content_item">
          <p class="clear_style zt14 black" @click="showKbViewAction()">K币抵扣<img class="address_detail_icon fr" style="margin: 0.15rem" src="@/images/icon_arrow_Put away@3x.png"><span class="fr address_phone themeColor zt12">{{yetUseKCoinInfo.yetUseKCoin > 0 ? '-¥'+yetUseKCoinInfo.yetUseKCoin:'-¥0.00'}}</span></p>
        </div>

        <!--comments-->
        <div class="content_item">
          <textarea  class="clear_style zt14 black" placeholder="请输入订单备注(非必填)" v-model="comments" maxlength="100" style="width:100%;height: 3rem;resize: none;border:0"></textarea>
        </div>

      </div>

      <!--优惠券/活动上拉菜单-->
      <div ref="markView" class="goods-action-activity-shadow" @click="hideActivity()"></div>
      <div ref="couponsView" class="goods-action-activity-content animate_action">
        <div class="goods-action-activity-title full_w">
          <span class="zt14 black tc fl" style="margin-left: 1rem">可用优惠券</span>
          <span @click="cancelCoupon()" class="zt14 grey tc fr" style="margin-right: 1rem">不使用优惠券</span>
        </div>
        <div style="background-color: white;padding: 0 0.5rem;width: 23rem;position: absolute;height: 28rem;overflow-y: scroll;" class="clear_both">
          <div class="coupon_item" v-for="(code,index) in productPromoCodeAvaliableList" @key="index">
            <img style="position: absolute;width: 22.5rem" src="@/images/bj_coupon2@3x.png">
            <div style="position: absolute;width: 22rem;padding-top: 0.5rem">
              <div class="fl" style="width: 2rem;height: 3.3rem">
                <p class="clear_style zt12 white" style="padding-left: 0.2rem;margin:0 auto;writing-mode: vertical-lr;width: 2rem;height: 5.5rem" :class="code.description.length > 7?'':'coupon_item_width'">{{code.description}}</p>
              </div>
              <div class="fl" style="padding-left: 1rem;margin-top: -0.6rem;width: 12rem">
                <div>
                  <div class="clear_style zt48 blod tc fl wpurple" style="padding-left: 1rem;width: 7rem">{{getPromoValue(code)}}</div>
                  <div class="fl" style="padding-top: 0.7rem;margin-left: 0.5rem">
                    <p class="clear_style zt14 blod tc wpurple">{{getPromoType(code.type)}}</p>
                    <span class="zt14 blod wpurple">{{code.type=="discount"?'折':'RMB'}}</span>
                  </div>
                </div>
                <p class="clear_style zt10 tc fl full_w">
                  <span class="coupon_item_date wpurple">有效期:{{getPromoDate(code)}}</span>
                </p>
                <p class="clear_style zt14 white tc fl full_w" style="line-height: 1rem;height: 1.5rem;;overflow: hidden">{{code.productPromoName}}</p>
              </div>
              <!--已经使用的就不展示立即使用了-->
              <button v-if="code.productPromoCodeId != currentCoupons" @click="changeCoupons(code.productPromoCodeId)" class="zt12 white fr" style="border: 1px solid white;padding: 0.1rem 0.5rem;border-radius: 1.5rem;margin: 2rem 0.5rem;width: 5rem;">立即使用</button>
            </div>
          </div>
        </div>
      </div>

      <van-popup position="bottom" v-model="showKbView" >
        <div style="padding: 1rem 0 2rem 0">
          <div class="blod zt14 black tc" style="padding-bottom: 0.5rem">K币抵扣</div>
          <van-cell-group>
            <van-cell clickable name="不使用" title="不使用" @click="unCheckKCoinAction()">
              <template #right-icon>
                <van-checkbox name="a1" :disabled="canUseKCoinInfo.KCoinAmount == 0" v-model="kbselect1" checked-color="#EB84AB" ref="checkboxes1" />
              </template>
            </van-cell>
            <van-cell title="K币" :value="'总计可抵扣¥' + canUseKCoinInfo.KCoinAmount" :border="false" />
            <div v-if="mayUseActCoin=='Y'" style="padding: 0.5rem 0.5rem 0.5rem 1rem"><div class="dsinnerblock zt14 black" :class="!(canUseKCoinInfo.canUseActCoin>0)||kbselect2==false||kbselect1==true?'disabled_grey':''" style="width: 5rem;">- 活动币</div><div class="dsinnerblock zt14 black tr" :class="!(canUseKCoinInfo.canUseActCoin>0)||kbselect2==false||kbselect1==true?'disabled_grey':''" style="width: 15rem;margin-right: 0.3rem">可用{{canUseKCoinInfo.canUseActCoin}}活动币抵用{{canUseKCoinInfo.canUseActCoin}}元</div><van-checkbox class="dsinnerblock fr" style="margin-right: 0.3rem" @click="kbselect2Action()" v-model="kbselect2" shape="square" name="a1" :disabled="!(canUseKCoinInfo.canUseActCoin>0)||kbselect1"  checked-color="#EB84AB" ref="checkboxes2" /></div>
            <div v-if="mayUseCardCoin=='Y'" style="padding: 0.5rem 0.5rem 0.5rem 1rem"><div class="dsinnerblock zt14 black" :class="!(canUseKCoinInfo.canUseActCoin>0)||kbselect3==false||kbselect1==true?'disabled_grey':''" style="width: 5rem;">- 卡币</div><div class="dsinnerblock zt14 black tr" :class="!(canUseKCoinInfo.canUseActCoin>0)||kbselect3==false||kbselect1==true?'disabled_grey':''" style="width: 11rem;margin-right: 0.3rem">最高可用{{kbselect2==true?(canUseKCoinInfo.KCoinAmount-canUseKCoinInfo.canUseActCoin).toFixed(1):getMinValueAction()}}卡币</div><input ref="kCoinInput" @change="inputkCoinAction($event)" type="number" @keydown="handleInput2" :value="useCardCoinNum" :disabled="!(canUseKCoinInfo.canUseCardCoin>0)||kbselect3==false||kbselect1" class="dsinnerblock zt14 tc" style="width: 2.7rem;height: 0.9rem;vertical-align: super;border: 1px solid #eaeaea" /><van-checkbox class="dsinnerblock fr" style="margin-right: 0.3rem;" @click="kbselect3Action()" :disabled="!(canUseKCoinInfo.canUseCardCoin>0)||kbselect1" v-model="kbselect3" shape="square" name="a1" checked-color="#EB84AB" ref="checkboxes3" /></div>
            <div style="padding: 0rem 2rem 0.5rem 1rem" v-show="showTipsView" class="zt12 s1 tr">* 您最多使用 {{kbselect2==true?(canUseKCoinInfo.KCoinAmount-canUseKCoinInfo.canUseActCoin).toFixed(1):getMinValueAction()}} K币</div>
          </van-cell-group>
          <div class="tc" style="padding-top: 3rem"><van-button @click="makeKCoinSettingAction()" round style="width: 21rem" color="#EB84AB" type="primary" >确认</van-button></div>
        </div>
      </van-popup>

      <!--结算-->
      <div class="balance_view">
        <van-button class="fr" ref="jiesuanBtn" color="#AF97E7" style="width: 7rem;height: 3rem" type="primary" :loading="nextStepLoading" loading-text="去支付" @click="creatOrder()" >去支付</van-button>
        <p class="fl zt14 black" style="margin-left: 1rem">金额:<span class="zt16 total_price_view">¥{{totalPrices}}</span></p>
        <p class="fl zt12 black" style="margin-left: 0.5rem;color: #666666;line-height: 2rem">已优惠:<span class="zt12 total_price_view" style="color: #666666">¥{{favorable}}</span></p>
      </div>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,severUrl,shareOnlineUrl,paymentUrl } from '@/router/Constant'
  import { cartToOrderImputedPrice,getProductPromoCodeAvailable,createOrder,login,weixinPays,cloudPays } from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import {Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import { Popup,Checkbox, CheckboxGroup,Cell, CellGroup } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'orderComfirm',
    data() {
      return {
        token:getStore('externalLoginKey'),
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        totalPrices:0,
        favorable:0,
        freight:0,
        productAmount:0,
        showLoading:true,
        partyMessage:[],
        productList:[],
        productPromoCodeList:[],
        promoUseList:[],
        shipMethod:[],
        shoppingAddress:[],
        productPromoCodeAvaliableList:[],
        currentCoupons:"",
        currentContactMechId:"",
        showCoupons:false,
        nextStepLoading:false,
        payMap:{},
        comments:'',
        scanCode:'',
        showKbView:false,
        canUseKCoinInfo:[],
        yetUseKCoinInfo:[],
        useCardCoinNum:'',   //默认进来是空str，如果是数字说明已经操作过了
        useActCoinNum:'',
        kbselect1:false,
        kbselect2:false,
        kbselect3:false,
        showTipsView:false,
        showTips:"Y",
        mayUseActCoin:'',//是否可用活动币
        mayUseCardCoin:''//是否可用卡币
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [Popup.name]: Popup,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      footerView,
      loading,
      refresh
    },
    methods: {
      async initData() {
        if (getStore('currentAddress') == "" || getStore('currentAddress') == undefined) {
          setStore('currentAddress', '');
        }
        this.cartToOrderImputedPrice();
        this.getProductPromoCodeAvailable();
      },
      cartToOrderImputedPrice() {
        var param = {
          externalLoginKey: getStore('externalLoginKey'),
          productStoreId: this.productStoreId,
          partyName: "",
          contactNumber: this.currentContactMechId,
          partyIdNumber: "",
          productPromoCodeId: this.currentCoupons,
          useCardCoinNum:this.useCardCoinNum,
          useActCoinNum:this.useActCoinNum,
        }
        if (getStore('currentAddress')!=""&&getStore('currentAddress')!=undefined) {
          param['contactMechId'] = getStore('currentAddress')
        }
        console.log(param)
        cartToOrderImputedPrice(param)
          .then(res => {
            console.log("cartToOrderImputedPrice");
            console.log(res);
            this.refreshData(res);
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              if (this.showCoupons == true) {
                this.hideActivity();
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },


      getProductPromoCodeAvailable() {
        getProductPromoCodeAvailable({
          externalLoginKey: getStore('externalLoginKey'),
          productStoreId: this.productStoreId
        })
          .then(res => {
            console.log("getProductPromoCodeAvailable")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              this.productPromoCodeAvaliableList = res.productPromoCodeList
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      creatOrder() {
        this.nextStepLoading = true
        console.log("comments======="+this.comments)
        createOrder({externalLoginKey: getStore('externalLoginKey'),comments:this.comments})
          .then(res => {
            setStore('currentAddress','')
            console.log("creatOrder")
            console.log(res)
            setTimeout(() => {
              if (res._ERROR_MESSAGE_) {
                Toast.fail(res._ERROR_MESSAGE_);
              } else {
                this.nextStepLoading = false
                if (this.totalPrices != 0) {
                  console.log(paymentUrl+'?orderId='+res.orderId+'&totalPrice='+this.totalPrices+'&externalLoginKey='+getStore('externalLoginKey'))
                  wx.miniProgram.navigateTo({url:paymentUrl+'?orderId='+res.orderId+'&totalPrice='+this.totalPrices+'&externalLoginKey='+getStore('externalLoginKey')})
                  // this.goPay(res.orderId)
                } else {
                  window.location.href = shareOnlineUrl + "orderList?externalLoginKey="+getStore('externalLoginKey')
                  // window.location.replace(severUrl + "/#/orderList")
                }
              }
            }, 1000);
          })
          .catch(err => {
            setStore('currentAddress','')
            console.log(err);
          });
      },
      // 显示活动/优惠券
      showActivity: function () {
        if (this.productPromoCodeAvaliableList.length > 0) {
          this.$refs.markView.style.bottom = '0px'
          this.$refs.markView.style.display = 'block'
          this.$refs.couponsView.style.bottom = '0px'
          this.showCoupons = true
        } else {
          return false
        }
      },

      // 隐藏活动/优惠券
      hideActivity: function () {
        this.$refs.markView.style.bottom = -window.innerHeight + 'px'
        this.$refs.couponsView.style.bottom = -window.innerHeight + 'px'
        this.showCoupons = false
      },
      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to, from, next) => {
          window.scrollTo(0, 0)
        })
      },
      refreshData(res) {
        this.mayUseActCoin = res.mayUseActCoin //是否可用活动币
        this.mayUseCardCoin = res.mayUseCardCoin //是否可用卡币
        this.totalPrices = res.amount.toFixed(2);
        this.favorable = res.favorable.toFixed(2);
        this.freight = res.freight.toFixed(2);
        this.partyMessage = res.partyMessage
        this.productList = res.productList
        this.productPromoCodeList = res.productPromoCodeList
        this.promoUseList = res.promoUseList
        this.shipMethod = res.shipMethod
        this.shoppingAddress = res.shoppingAddress
        this.canUseKCoinInfo = res.canUseKCoinInfo
        this.yetUseKCoinInfo = res.yetUseKCoinInfo
        this.useCardCoinNum = res.yetUseKCoinInfo.yetUseCardCoin    // 进来默认有值
        this.useActCoinNum = res.yetUseKCoinInfo.yetUseActCoin    // 进来默认有值
        this.useActCoinNum > 0 ? this.kbselect2 = true : this.kbselect2 = false
        this.useCardCoinNum > 0 ? this.kbselect3 = true : this.kbselect3 = false
        this.canUseKCoinInfo.KCoinAmount == 0 ? this.kbselect1 = true : this.kbselect1 = false
        if (this.shoppingAddress.contactMechId) {
          setStore('currentAddress', this.shoppingAddress.contactMechId)
        }
        this.productAmount = res.productAmount.toFixed(2);
        if (res.productPromoCodeList.length > 0) {
          this.currentCoupons = res.productPromoCodeList[0].productPromoCodeId
        } else {
          this.currentCoupons = ""
        }
        this.currentContactMechId = res.shoppingAddress.contactMechId
      },
      changeCoupons(couponsId) {
        this.currentCoupons = couponsId;
        this.cartToOrderImputedPrice()
      },
      cancelCoupon() {
        this.currentCoupons = "-" + this.currentCoupons;
        this.cartToOrderImputedPrice()
      },
      // 显示K币
      showKbViewAction(){
        if (this.canUseKCoinInfo.canUseKCoin > 0) {
          this.showKbView = true
        } else {
          return
        }
      },
      // 隐藏K币
      hideKbViewAction(){
        this.showKbView = false
      },
      unCheckKCoinAction() {
        if (this.canUseKCoinInfo.KCoinAmount == 0) {
          this.kbselect1 = true
          return
        }
        this.$refs.checkboxes1.toggle();
        console.log('this.kbselect1====' + this.kbselect1)
        this.kbselect1=!this.kbselect1
        console.log('this.kbselect1====' + this.kbselect1)
        if (this.kbselect1 == true) {
          this.kbselect2 = false
          this.useActCoinNum = 0
          this.kbselect3 = false
          this.useCardCoinNum = 0
          this.showTipsView = false
        } else {
          if (this.canUseKCoinInfo.canUseActCoin > 0 ) {
            this.kbselect2 = true
          }
          this.useActCoinNum = this.canUseKCoinInfo.canUseActCoin
          if (this.canUseKCoinInfo.canUseCardCoin > 0 ) {
            this.kbselect3 = true
          }
          this.useCardCoinNum = this.canUseKCoinInfo.KCoinAmount-this.canUseKCoinInfo.canUseActCoin
        }
      },
      inputkCoinAction(event){
        this.useCardCoinNum = this.$refs.kCoinInput.value
        console.log(event.currentTarget.value)
        console.log(this.useCardCoinNum)
        console.log(this.$refs.kCoinInput.value)
        if (this.kbselect2 == true) {  // 如果已勾选 value <= 总数 - 活动币
          if (this.$refs.kCoinInput.value <= (this.canUseKCoinInfo.KCoinAmount - this.canUseKCoinInfo.canUseActCoin) && this.$refs.kCoinInput.value <= this.canUseKCoinInfo.canUseCardCoin){
            console.log('数量正确')
            this.showTipsView = false
          } else {
            this.showTipsView = true
            this.useCardCoinNum = (this.canUseKCoinInfo.KCoinAmount - this.canUseKCoinInfo.canUseActCoin).toFixed(1)
          }
        } else {                      // 如果未勾选 value <= 总数
          if (this.$refs.kCoinInput.value <= this.canUseKCoinInfo.canUseKCoin && this.$refs.kCoinInput.value <= this.canUseKCoinInfo.canUseCardCoin){
            console.log('数量正确')
            this.showTipsView = false
          } else {
            this.showTipsView = true
            this.useCardCoinNum = this.getMinValueAction()
          }
        }
      },
      kbselect2Action(){
        if (this.kbselect1 == true) {
          return false
        } else {
          this.kbselect2 == false ? this.useActCoinNum = 0 : this.useActCoinNum = this.canUseKCoinInfo.canUseActCoin
          this.kbselect2 == false ? this.useCardCoinNum = this.getMinValueAction() :(this.useCardCoinNum = this.canUseKCoinInfo.KCoinAmount-this.canUseKCoinInfo.canUseActCoin).toFixed(1)
          if (this.KCoinAmount)
          this.kbselect3 = true
        }
      },

      kbselect3Action(){
        if (this.kbselect1 == true) {
          return false
        } else {
          if (this.kbselect2 == true) {
            this.kbselect3 == false ? this.useCardCoinNum = 0 : this.useCardCoinNum = (this.canUseKCoinInfo.KCoinAmount-this.canUseKCoinInfo.canUseActCoin).toFixed(1)
          } else {
            if (this.canUseKCoinInfo.canUseCardCoin > this.canUseKCoinInfo.KCoinAmount ) {
              this.kbselect3 == false ? this.useCardCoinNum = 0 : this.useCardCoinNum = this.canUseKCoinInfo.KCoinAmount
            } else {
              this.kbselect3 == false ? this.useCardCoinNum = 0 : this.useCardCoinNum = this.canUseKCoinInfo.canUseCardCoin
            }
          }
        }
      },
      getMinValueAction(){
        var minV = 0
        if (this.canUseKCoinInfo.KCoinAmount < this.canUseKCoinInfo.canUseCardCoin) {
          minV = this.canUseKCoinInfo.KCoinAmount
        } else if (this.canUseKCoinInfo.canUseCardCoin < this.canUseKCoinInfo.KCoinAmount) {
          minV = this.canUseKCoinInfo.canUseCardCoin
        } else {
          minV = this.canUseKCoinInfo.canUseCardCoin
        }
        return minV
      },
      handleInput2(e) {
        e.target.value = (e.target.value.match(/^\d*(\.?\d{0})/g)[0]) || null
      },
      makeKCoinSettingAction(){
        this.showKbView = false
        console.log("this.useActCoinNum=======" + this.useActCoinNum)
        console.log("this.useCardCoinNum========" + this.useCardCoinNum)
        this.cartToOrderImputedPrice()
      },
      // 规格属性拼接
      getFeatureString(featureList) {
        var featureString = ""
        if (featureList.length > 1) {
          for (var i = 0; i < featureList.length; i++) {
            if (i == featureList.length - 1) {
              featureString += featureList[i].productFeatureDescription
            } else {
              featureString += featureList[i].productFeatureDescription + "、"
            }
          }
        } else {
          for (var i = 0; i < featureList.length; i++) {
            featureString += featureList[i].productFeatureDescription
          }
        }
        return featureString;
      },
      getPromoType(type) {
        var typeName = '';
        switch (type) {
          case 'gift':
            typeName = '礼品券'
            break;
          case 'discount':
            typeName = '折扣券'
            break;
          case 'deduct':
            typeName = '满减券'
            break;
          case 'special':
            typeName = '特价券'
            break;
          default:
            break
        }
        return typeName
      },
      getPromoDate(item) {
        var msg = ""
        if (item.fromDate == null && item.thruDate == null) {
          msg = "不限制时间使用"
        }
        if (item.fromDate == null && item.thruDate != null) {
          msg = "截止到" + this.transDate(item.thruDate) + "失效"
        }
        if (item.fromDate != null && item.thruDate == null) {
          msg = this.transDate(item.fromDate) + "后开始使用"
        }
        if (item.fromDate != null && item.thruDate != null) {
          msg = this.transDate(item.fromDate) + "-" + this.transDate(item.thruDate)
        }
        return msg
      },
      getPromoValue(code) {
        var promoValue = '';
        switch (code.type) {
          case 'gift':
            promoValue = '赠品'
            break;
          case 'discount':
            if (code.value == 0) {
              promoValue = '免费'
            } else {
              if ((parseInt(code.value, 10) === code.value)==true) {
                promoValue = code.value + '.0'
              } else {
                promoValue = code.value
              }
            }
            break;
          case 'deduct':
            promoValue = code.value
            break;
          case 'special':
            if (code.value == 0) {
              promoValue = '免费'
            } else {
              promoValue = code.value
            }
            break;
          default:
            break
        }
        return promoValue
      },
      transDate(value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          return y + '.' + MM + '.' + d
        }else{
          return ''
        }
      },
      // 用户支付
      goPay:function (orderId) {
        let params = {
          orderId:orderId,
          externalLoginKey:getStore('externalLoginKey'),
        }
        weixinPays(params)
          .then(res => {
            console.log(res);
            console.log('goPay')
            if(!res._EVENT_MESSAGE_){


              // this.scanCode = res.scanCode
              // console.log("scanCode========="+this.scanCode)
              // window.location.href = this.scanCode


              this.payMap = res.payMap
              if (typeof WeixinJSBridge == "undefined"){
                if( document.addEventListener ){
                  document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
                }else if (document.attachEvent){
                  document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
                  document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady());
                }
              }else{
                this.onBridgeReady();
              }
            }else{
              Toast({message:'获取参数失败'})
            }
          })
          .catch(err => {
            this.showLoading = false
            console.log(err);
          });
      },


      //支付参数获取成功后掉取方法
      onBridgeReady:function(){
        console.log("this.payMap================")
        console.log(this.payMap)
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId":this.payMap.appId,     //公众号名称，由商户传入
            "timeStamp":this.payMap.timeStamp,         //时间戳，自1970年以来的秒数
            "nonceStr":this.payMap.nonceStr, //随机串
            "package":this.payMap.package,
            "signType":this.payMap.signType,         //微信签名方式：
            "paySign":this.payMap.paySign //微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ){
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              Toast({message:'支付成功'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
              Toast({message:'取消支付'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }else if(res.err_msg == "get_brand_wcpay_request:fail"){
              Toast({message:'支付失败'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }
          });
      },
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    },
    beforeDestroy() {
      setStore('currentAddress', '');
    }
  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 14rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 14.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.1rem;color: #EB84AB;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  .content_item {
    background-color: white;padding: 0.7rem 0.5rem;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #EB84AB;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 18rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

  /*商品活动/优惠券*/
  .goods-action-activity-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: none;
    z-index: 99;
  }
  .goods-action-activity-content{
    width:100%;
    height:30.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    padding-bottom: 1rem;
    z-index: 99;
  }
  .goods-action-activity-title{
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size:1rem;
    color:#333312;
  }
  .goods-action-activity-content-bottom{
    width:21.4375rem;
    margin:0 auto;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-activity-content-name{
    font-size:1rem;
    color:#333312;
    height: 3rem;
    line-height: 3rem;
  }
  .goods-action-activity-content-list{
    width:100%;
  }
  .goods-action-activity-content-each{
    width:100%;
    height: 6.875rem;
    margin-bottom: 0.3125rem;
  }
  .goods-action-activity-content-each img{
    width:100%;
    height: 100%;
  }
  .goods-action-activity-content-list-left{
    display: inline-block;
    vertical-align: top;
    width:2rem;
  }
  .goods-action-activity-content-list-left img{
    width:1.25rem;
    height:0.90625rem;
  }
  .goods-action-activity-content-list-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3.5rem);
  }
  .goods-action-activity-content-each-left{
    display: inline-block;
    vertical-align: top;
    width:5rem;
    position: relative;
    top: -5rem;
    left: 2.4rem;
  }
  .goods-action-activity-price{
    color:white;
    font-size: 1.71875rem;
  }
  .goods-action-activity-content-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 5rem);
    position:relative;
    top: -8rem;
    left: 8rem;
  }
  .goods-action-activity-content-desc{
    color:#EB84AB;
    font-size:0.9375rem;
    margin-bottom: 0.6875rem;
  }
  .goods-action-activity-content-time{
    color:#666;
    font-size:0.625rem;
    margin-bottom: 0.96875rem;
  }
  .goods-action-activity-content-status{
    width:100%;
    height: 1.40625rem;
  }
  .goods-action-activity-content-status-desc{
    color:#999;
    font-size: 0.75rem;
    display: inline-block;
    vertical-align: top;
    width: 7rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    height: 1.40625rem;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button{
    width:4.6875rem;
    height: 1.40625rem;
    display: inline-block;
    vertical-align: top;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button button{
    width:100%;
    font-size: 0.75rem;
    color:#EB84AB;
    text-align: center;
    line-height: 1.40625rem;
    border-radius:0.703125rem;
    border:1px solid #EB84AB;
  }
  .goods-action-activity-desc{
    color:#EB84AB;
    font-size:1rem;
  }
  .goods-action-activity-time{
    font-size:0.875rem;
    color:#999;
    line-height: 2rem;
  }

  .coupon_item {
    height: 7rem;
  }

  .coupon_item_width {
    width: 1rem!important;
  }

  .coupon_item_date {
    line-height: 1rem;border-top: 1px solid #6547AA;padding-top: 0.4rem;
  }

  .disabled_grey {
    color: #969799!important;
  }

  .van-cell__value {
    color: #333333;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/order/orderComfirm.vue